import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {QueryService} from "../../Services/query-service";
import {QueryNode} from "@ispm-client/modules/query-builder/models/query-builder-config";
import {Factor} from "../../model/factor";

@Component({
  selector: 'gen-field-viewer',
  templateUrl: './field-viewer.component.html',
  styleUrls: ['./field-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldViewerComponent {

  @Input() field: Factor;

  constructor(private queryService: QueryService) {
  }

  ngOnInit() {
  }

  getText(): string[] {
    let queryNode: QueryNode = this.field.queryNode;
    if (queryNode) {
      let rule = queryNode.rules[0];
      let ruleType = rule.type.toUpperCase();
      if (ruleType == "PARAMETER" && rule.parameter) {
        return this.queryService.getRepresentation(queryNode);
      }
      else if (ruleType == "PARAMETER_SET" && rule.rules[0].parameter) {
        return this.queryService.getRepresentation(queryNode);
      }
    }
    //must be an empty factor
    return new Array<string>("");
  }

}
